export var CurrentBreakpoint;
(function (CurrentBreakpoint) {
    CurrentBreakpoint["XX"] = "xx";
    CurrentBreakpoint["XS"] = "xs";
    CurrentBreakpoint["SM"] = "sm";
    CurrentBreakpoint["MD"] = "md";
    CurrentBreakpoint["LG"] = "lg";
})(CurrentBreakpoint || (CurrentBreakpoint = {}));
